/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rail_LabelInputs */

const en_rail_label = /** @type {(inputs: Rail_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where you are`)
};

/**
* | output |
* | --- |
* | "Where you are" |
*
* @param {Rail_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const rail_label = /** @type {((inputs?: Rail_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rail_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_rail_label(inputs)
});